import { Image, TextButton, TOPBAR_HEIGHT } from '@capsicum/common-web';
import { HeaderWarning } from '@capsicum/features/regulations/web';
import { styled } from 'styled-components';

export const StyledTextButton = styled(TextButton)`
	flex-shrink: 0;
`;

export const Wrapper = styled.div`
	width: 100%;
	display: flex;
	flex-direction: column;
`;

export const ProductUkHeaderWarning = styled(HeaderWarning)`
	background-color: ${({ theme }) => theme.colors.backgrounds.main.screen};
	top: ${TOPBAR_HEIGHT}px;
`;

export const CategoryTitle = styled.div`
	${({ theme }) => theme.fonts.headings.title5};
	color: ${({ theme }) => theme.colors.text.main.enabled};
	margin: ${({ theme }) => theme.spacings.xxlarge} 0 ${({ theme }) => theme.spacings.large};
	${({ theme }) => theme.breakpoints.queries.below.tabletSmallDesktop} {
		margin-left: ${({ theme }) => theme.spacings.small};
	}
`;

export const ProductWrapper = styled.div`
	background-color: ${({ theme }) => theme.colors.backgrounds.main.container};
	width: 100%;
	display: grid;
	grid-template-columns: calc(50% - 10px) calc(50% - 10px);
	grid-column-gap: ${({ theme }) => theme.spacings.small};
	padding: ${({ theme }) => theme.spacings.small};
	${({ theme }) => theme.border.radius.medium};
	${({ theme }) => theme.breakpoints.queries.only.mobile} {
		display: flex;
		flex-direction: column;
		margin-bottom: 70px;
	}
`;

export const ImageWrapper = styled.div`
	display: flex;
	flex-direction: column;
	width: 100%;
	${({ theme }) => theme.breakpoints.queries.only.mobile} {
		margin-bottom: ${({ theme }) => theme.spacings.medium};
	}
`;

export const GalleryView = styled.div`
	display: flex;
	width: 100%;
	overflow: hidden;
	margin-top: ${({ theme }) => theme.spacings.medium};
	&:hover {
		overflow-x: scroll;
	}
	${({ theme }) =>
		theme.breakpoints.queries.builder.or(
			theme.breakpoints.queries.above.tabletSmallDesktop,
			theme.breakpoints.queries.only.mobile
		)} {
		&:hover {
			overflow-x: unset;
		}
	}
	${({ theme }) => theme.breakpoints.queries.only.mobile} {
		margin-bottom: ${({ theme }) => theme.spacings.medium};
		margin-top: 0;
	}
`;

export const StyledCardImagePlaceholder = styled.div`
	height: 254px;
	width: 100%;
	background-color: ${({ theme }) => theme.colors.skeleton.default};
`;

export const StyledImage = styled(Image)`
	object-fit: contain;
`;

export const Pressable = styled.div<{ $selected: boolean }>`
	margin-right: ${({ theme }) => theme.spacings.xxsmall};
	border: ${({ $selected, theme }) =>
		$selected
			? `${theme.border.width.large} solid ${theme.colors.borders.brand.selected}`
			: `${theme.border.width.large} solid ${theme.colors.backgrounds.transparent}`};
`;

export const DetailsWrapper = styled.div`
	display: flex;
	flex-direction: column;
	flex: 1;
`;

export const ProductImage = styled(Image)`
	object-fit: contain;
	width: 100%;
	margin: 0 auto;
	${({ theme }) =>
		theme.breakpoints.queries.builder.or(
			theme.breakpoints.queries.above.mediumDesktop,
			theme.breakpoints.queries.only.mobile
		)} {
	}
`;

export const ImageContainer = styled.div`
	width: 100%;
	max-width: 100%;
	${({ theme }) => theme.breakpoints.queries.only.mobile} {
		margin-bottom: ${({ theme }) => theme.spacings.medium};
	}
`;

export const HeaderWrapper = styled.div`
	display: flex;
	margin-bottom: ${({ theme }) => theme.spacings.small};
`;

export const TitleWrapper = styled.div`
	flex: 1;
	align-items: center;
`;

export const Category = styled.div`
	${({ theme }) => theme.fonts.text.caption1};
	color: ${({ theme }) => theme.colors.text.main.enabled};
`;

export const Title = styled.div`
	${({ theme }) => theme.fonts.headings.title6};
	color: ${({ theme }) => theme.colors.text.main.enabled};
`;

export const LabelsContainer = styled.div`
	display: flex;
	flex-direction: row;
	flex-flow: wrap;
	gap: ${({ theme }) => `${theme.spacings.xsmall} ${theme.spacings.xxsmall}`};
	align-items: center;
`;

export const ComingSoon = styled.div`
	display: flex;
	flex-direction: column;
	${({ theme }) => theme.fonts.headings.display4}
	align-items: center;
`;

export const LabelStatus = styled.div`
	${({ theme }) => theme.fonts.text.caption2};
	margin-bottom: ${({ theme }) => theme.spacings.xxxsmall};
	color: ${({ theme }) => theme.colors.text.main.enabled};
`;

export const OutOfStockText = styled.div`
	text-transform: uppercase;
	${({ theme }) => theme.fonts.headings.display4}
	margin-right: ${({ theme }) => theme.spacings.xxsmall};
	margin-bottom: ${({ theme }) => theme.spacings.small};
`;

export const TokensNeededText = styled.div`
	${({ theme }) => theme.fonts.text.text4};
	color: ${({ theme }) => theme.colors.text.main.enabled};
	padding-left: ${({ theme }) => theme.spacings.xxsmall};
	padding-right: ${({ theme }) => theme.spacings.xxxsmall};
	flex: 1;
	border: 0;
	word-break: break-all;
`;

export const AvailableIn = styled.div`
	margin-left: ${({ theme }) => `${theme.spacings.xxsmall}`};
	text-align: center;
	${({ theme }) => theme.fonts.text.caption2};
	text-transform: none;
`;

export const Divider = styled.div`
	margin-top: ${({ theme }) => theme.spacings.small};
	border-top: 1px solid ${({ theme }) => theme.colors.borders.main.divider};
`;

export const CategoryInfo = styled.div`
	margin-top: ${({ theme }) => theme.spacings.small};
	border-top: 1px solid ${({ theme }) => theme.colors.borders.main.divider};
	display: flex;
`;

export const DetailsTitle = styled.div`
	margin-top: ${({ theme }) => theme.spacings.small};
	${({ theme }) => theme.fonts.text.text1}
	color: ${({ theme }) => theme.colors.text.main.enabled};
`;

export const InfoWrapper = styled.div`
	margin-right: ${({ theme }) => theme.spacings.medium};
`;

export const BuyTokensLabel = styled.div`
	display: flex;
	${({ theme }) => theme.border.radius.circle};
	box-sizing: border-box;
	justify-content: center;
	align-items: center;
	flex-direction: row;
	padding: ${({ theme }) => `${theme.spacings.xxxsmall} ${theme.spacings.xsmall}`};
	border: 1px solid ${({ theme }) => theme.colors.borders.main.divider};
`;

export const DetailsValue = styled.div`
	${({ theme }) => theme.fonts.text.text3}
	color: ${({ theme }) => theme.colors.text.main.enabled};
`;

export const BlockTitle = styled.div<{ $isMarginBottom?: boolean }>`
	margin-top: ${({ theme }) => theme.spacings.small};
	margin-bottom: ${({ $isMarginBottom, theme }) => ($isMarginBottom ? theme.spacings.small : 0)};
	${({ theme }) => theme.fonts.text.text1}
	color: ${({ theme }) => theme.colors.text.main.enabled};
`;

export const Description = styled.div`
	${({ theme }) => theme.fonts.text.text3}
	color:${({ theme }) => theme.colors.text.main.enabled};
	white-space: pre-line;
`;

export const ButtonWrapper = styled.div`
	margin-top: ${({ theme }) => theme.spacings.small};
	align-self: end;

	${({ theme }) => theme.breakpoints.queries.below.mobile} {
		position: fixed;
		width: 100%;
		bottom: 0;
		left: 0;
		margin-top: 0;
		padding: ${({ theme }) => theme.spacings.small};
		background-color: ${({ theme }) => theme.colors.backgrounds.main.container};
		display: flex;
		flex-direction: row;
		align-self: center;
	}
`;

export const Link = styled.a`
	color: ${({ theme }) => theme.colors.text.brand.enabled};
	${({ theme }) => theme.fonts.text.text3};
	text-decoration: none;
`;

export const importantInformationList = styled.ol`
	padding-left: ${({ theme }) => theme.spacings.small};
	margin: 0;
`;

export const importantInformationItem = styled.li`
	${({ theme }) => theme.fonts.text.text3}
	color: ${({ theme }) => theme.colors.text.main.enabled};
`;

export const InformationWrapper = styled.div`
	margin-top: ${({ theme }) => theme.spacings.small};
	margin-bottom: ${({ theme }) => theme.spacings.small};
`;
